import { createSlice } from '@reduxjs/toolkit';

interface ThemeState {
  selectedTheme: string;
}

const loadTheme = (): string => {
  return localStorage.getItem('selectedTheme') || 'light';
};

const initialState: ThemeState = {
  selectedTheme: loadTheme(),
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state, action) => {
      state.selectedTheme = action.payload;
      localStorage.setItem('selectedTheme', action.payload);
      console.log(state.selectedTheme);
    },
  },
});

export const { toggleTheme } = themeSlice.actions;
export default themeSlice.reducer; 